export default __webpack_public_path__ + "static/media/contactMail.bddfd426.svg";